import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {SubscriptionService} from '../service/subscription.service';
import {SubscriptionType} from '../enums/subscription-type';
import {map, catchError} from 'rxjs/operators';
import {of} from 'rxjs';

export const isPremiumMenuGuard: CanActivateFn = () => {
    const subscriptionService = inject(SubscriptionService);
    const router = inject(Router);

    return subscriptionService.getActiveIndividualSubscription().pipe(
        map(sub => {
            if (sub?.subscriptionInfoResponse?.subscriptionType === SubscriptionType.PREMIUM && !sub?.isExpired) {
                return true;
            }
            router.navigate(['/subscriptions']);
            return false;
        }),
        catchError(() => {
            router.navigate(['/subscriptions']);
            return of(false);
        })
    );
};
